export default __webpack_public_path__ + "3e81d0dab9eeddcf46bb604d348f09f2.png";